import React from "react";
import parse from "html-react-parser";
import { InlineMath } from "react-katex";

import "katex/dist/katex.min.css";

const handleKatexRenderError = (err) => {
  console.log(err?.message);
  return (
    <b style={{ color: "#cc0000" }}>
      Sorry, we could not render this expression
    </b>
  );
};

/**
 * Parses skill and subskill headings that capture LaTeX expressions using ||...||
 */
export const parseName = (name) => {
  return name.split("||").map((str, i) => {
    if (i % 2 === 0) {
      return <span key={i}>{parse(str)}</span>;
    } else {
      return (
        <span key={i} className="whitespace-nowrap">
          <InlineMath renderError={handleKatexRenderError}>{str}</InlineMath>
        </span>
      );
    }
  });
};

/**
 * Parse topic tree path
 */
export const parsePath = (path, topic = "") => {
  const pathArray = JSON.parse(path);
  const itemsToJoin = pathArray.map((p) => {
    switch (p.name) {
      case "KS2":
        return "Primary";
      case "KS3/4":
        return "Secondary";
      case "KS5":
        return "A Level";
      default:
        return p.name;
    }
  });
  const joinedItems = itemsToJoin.join(" | ");
  const pathString = topic ? `${joinedItems} | ${topic}` : joinedItems;
  return parseName(pathString);
};
